function PreviousIcon(props: React.SVGProps<SVGSVGElement>) {
  const { fill = 'currentcolor' } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8.855" height="14.881" viewBox="0 0 8.855 14.881" {...props}>
      <path
        id="Tracé_84136"
        data-name="Tracé 84136"
        d="M-4111.027,2480.315l-6.734,6.734,6.734,6.734"
        transform="translate(4119.175 -2479.608)"
        fill="white"
        stroke={fill}
        strokeWidth="2"
      />
    </svg>
  );
}
export default PreviousIcon;
